import { useCallback, useEffect, useState } from "react";
const MOBILE_BREAKPOINT_PX = 700;
const useFolderTreeResponsive = ({ isModal = false, initialMobile } = {})=>{
    const [isMobile, setIsMobile] = useState(()=>initialMobile ?? (!isModal && typeof window !== "undefined" && window.innerWidth <= MOBILE_BREAKPOINT_PX));
    const [isSticky, setIsSticky] = useState(isModal ? false : !isMobile);
    const [isStickyHeader, setIsStickyHeader] = useState(isModal ? false : !isMobile);
    const [isResizable, setIsResizable] = useState(isModal ? false : !isMobile);
    const [isFullWidth, setIsFullWidth] = useState(isModal ? true : isMobile);
    const [style, setStyle] = useState(isMobile && !isModal ? {
        marginLeft: 10
    } : {});
    const applyLayout = useCallback((layout)=>{
        layout.isSticky !== undefined && setIsSticky(layout.isSticky);
        layout.isStickyHeader !== undefined && setIsStickyHeader(layout.isStickyHeader);
        layout.isResizable !== undefined && setIsResizable(layout.isResizable);
        layout.isFullWidth !== undefined && setIsFullWidth(layout.isFullWidth);
        layout.style !== undefined && setStyle(layout.style);
    }, []);
    useEffect(()=>{
        if (isModal) {
            return undefined;
        }
        const handleResize = ()=>{
            const mobile = window.innerWidth <= MOBILE_BREAKPOINT_PX;
            setIsMobile(mobile);
            setIsSticky(!mobile);
            setIsStickyHeader(!mobile);
            setIsResizable(!mobile);
            setIsFullWidth(mobile);
            setStyle(mobile ? {
                marginLeft: 10
            } : {});
        };
        window.addEventListener("resize", handleResize);
        return ()=>window.removeEventListener("resize", handleResize);
    }, [
        isModal
    ]);
    return {
        isSticky,
        isStickyHeader,
        isResizable,
        isFullWidth,
        style,
        applyLayout,
        isMobile
    };
};
export { useFolderTreeResponsive };
